import { useCallback } from 'react';
import { useBackButton } from '../../../utils/useBackButton';
import { useTranslation } from '../../../utils/useTranslation';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from '../../feedback/Dialog';
import { Box } from '../../layout/Box';
import { Typography } from '../../typography/Typography';
import { DIALOG_MAX_WIDTH } from './constants';
import { DirectAuthLink } from './styles';

export const DirectAuthorizationDialog = () => {
    const onNavigateBack = useBackButton();

    const t = useTranslation();

    const onClose = useCallback(() => {
        onNavigateBack();
    }, [onNavigateBack]);

    return (
        <Dialog
            height={{ xs: 'auto' }}
            onClose={onClose}
            maxWidth={DIALOG_MAX_WIDTH}
            borderRadius={2}
            px={1}
        >
            <DialogTitle
                borderRadius="16px 16px 0 0 "
                px={2}
                withBorderBottom={false}
                onClose={onClose}
            >
                <Typography variant="title3" weight="bold">
                    {t('Авторизация')}
                </Typography>
            </DialogTitle>
            <DialogContent px={2} py={0}>
                <Typography variant="body">
                    {t(
                        'Продвижение постов происходит с помощью технологий Яндекс Директа. Для того, чтобы начать продвижение, необходимо зарегистрироваться или авторизоваться в личном кабинете Директа',
                    )}
                </Typography>
            </DialogContent>
            <DialogFooter
                borderRadius="0 0 16px 16px"
                overflow="visible"
                px={2}
                withBorderTop={false}
            >
                <Box width="100%" height="100%" backgroundColor="var(--background-primary-blur)">
                    <DirectAuthLink>{t('Авторизоваться')}</DirectAuthLink>
                </Box>
            </DialogFooter>
        </Dialog>
    );
};
